// import { logoutUser } from "../API/AuthApi";
/***************************
 * Common Utilities
 ***************************/
export const numberWithCommas = (number) => {
  if (!number) {
    return;
  }

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

//Function to capitalize first letter
export const capitalizeFirstLetter = (string) => {
  if (string) return string.charAt(0).toUpperCase() + string.slice(1);
  return null;
};

export function formatLabel(str) {
  if (!str) return ""; // Return empty string if null, undefined, or empty

  return str
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\b\w/g, (char) => char); // (Your current transformation)
}

export const capitalizeText = (text) => {
  return text?.charAt(0)?.toUpperCase() + text?.slice(1);
};

//Common Utility Functions

export const validateFileSize = (file) => {
  const maxSizeInBytes = 5 * 1024 * 1024; // 5MB

  if (file.size <= maxSizeInBytes) {
    return true; // File size is valid
  } else {
    return false; // File size is too large
  }
};

export const getResidentDetails = (user) => {
  const footerDetails = [
    {
      id: "28",
      name: "Airon May Estremos",
      prc_no: "PRC No. 0158271",
    },
    {
      id: "30",
      name: "Raul Jr. J. Pales",
      prc_no: "PRC No. 0158844",
    },
  ];

  const details = footerDetails.filter((item) => item.id === user);

  return details;
};

export const getTomorrowDate = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const year = tomorrow.getFullYear();
  const month = String(tomorrow.getMonth() + 1).padStart(2, "0");
  const day = String(tomorrow.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
// for date fields
export const getDateToday = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate());

  const year = tomorrow.getFullYear();
  const month = String(tomorrow.getMonth() + 1).padStart(2, "0");
  const day = String(tomorrow.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
export const formatDateYMD = (date) => {
  const formatDate = new Date(date);
  const year = formatDate.getFullYear();
  let month = formatDate.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  let day = formatDate.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  return `${year}-${month}-${day}`;
};

// Example: "2023-05-16" -> "May 16, 2023"
export const formatDateMMMMDYYYY = (dateString) => {
  const moment = require("moment");
  return moment(dateString).format("MMMM D, YYYY");
};

// Example: "2023-05-16" -> "2023-05-16
export const formatDateYYYYMMDD = (dateString) => {
  const moment = require("moment");
  return moment(dateString).format("YYYY-MM-DD");
};

// Example: "2023-05-16" -> "16th of May 2023"
export const formatDateWithSuffix = (dateString) => {
  const moment = require("moment");
  return moment(dateString).format("Do [of] MMMM YYYY");
};

// Function to remove commas from a string
export const removeCommas = (str) => {
  return str.replace(/,/g, "");
};

export const refreshPage = () => {
  window.location.reload();
};

export const getTime = (date) => {
  return date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
};

// ex. 10:30:09 AM
export const formatToTimeOnly = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  });
};

export const subtractMonths = (numOfMonths, date = new Date()) => {
  date.setMonth(date.getMonth() - numOfMonths);
  return date.toISOString().split("T")[0];
};

export const getTodayDate = () => {
  return new Date();
};

// YYYY-MM-DD
export const getTodayDateISO = () => {
  let date = new Date();
  return date.toISOString().split("T")[0];
};

export const getAge = (dateString) => {
  var today = new Date();
  var birthdate = new Date(dateString);
  var age = today.getFullYear() - birthdate.getFullYear();
  var m = today.getMonth() - birthdate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
    age--;
  }
  return age;
};

export const getMonths = (dateString) => {
  const today = new Date();
  const birthdate = new Date(dateString);

  let months = (today.getFullYear() - birthdate.getFullYear()) * 12;
  months += today.getMonth() - birthdate.getMonth();

  if (today.getDate() < birthdate.getDate()) {
    months--;
  }

  return months;
};

export const formatPrice = (p) => {
  var result = parseFloat(p)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,");
  return result;
};

export const formatDate = (date) => {
  var formatDate = new Date(date);
  var stringDate = formatDate.toDateString().split(" ");
  return stringDate[1] + " " + stringDate[2] + ", " + stringDate[3];
};

export const flattenPrescriptionRows = (rows) => {
  const safeRows = Array.isArray(rows) ? rows : [];

  return safeRows.flatMap((row) => {
    const details = row?.prescription_details;
    if (!details) {
      return [row];
    }

    const detailsArray = Array.isArray(details) ? details : [details];

    return detailsArray
      .filter(Boolean)
      .map((detail) => ({
        ...row,
        ...detail,
        id: row?.id ?? detail?.id,
        prescription_detail_id: detail?.id ?? null,
        added_on: detail?.added_on ?? row?.added_on,
        updated_on: detail?.updated_on ?? row?.updated_on,
      }));
  });
};

export const formatDateWithTime = (date) => {
  var formatDate = new Date(date);
  var stringDate = formatDate.toDateString().split(" ");
  return (
    stringDate[1] +
    " " +
    stringDate[2] +
    ", " +
    stringDate[3] +
    " " +
    formatDate.toLocaleTimeString().replace(/(.*)\D\d+/, "$1")
  );
};

export const formatDateNoTime = (date) => {
  var formatDate = new Date(date);
  var stringDate = formatDate.toDateString().split(" ");

  return stringDate[1] + " " + stringDate[2] + ", " + stringDate[3];
};

export const formatDateSlash = (date) => {
  var stringDate = date.split("-");

  return stringDate[1] + "/" + stringDate[2] + "/" + stringDate[0];
};

export const formatMDY = (date) => {
  var stringDate = date.split("-");
  return stringDate[1] + "-" + stringDate[2] + "-" + stringDate[0];
};

export const validateEmail = (email) => {
  if (email === "") {
    return true;
  } else {
    var filter =
      /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
    return String(email).search(filter) != -1;
  }
};

export const validateContact = (num) => {
  var mobileFilter = /((^(\+)(\d){12}$)|(^\d{11}$))/;
  var telFilter = /^[0-9]+(-[0-9]+)+$/;

  if (
    String(num).search(mobileFilter) != -1 ||
    String(num).search(telFilter) != -1
  ) {
    return true;
  } else {
    return false;
  }
};

export const formatNum = (num) => {
  return parseFloat(Math.round(num * 100) / 100).toFixed(2);
};

export const formatDateTimeField = (date) => {
  const originalDate = new Date(date);

  // Extract the year, month, day, hours, and minutes from the original date
  const year = originalDate.getFullYear();
  const month = String(originalDate.getMonth() + 1).padStart(2, "0");
  const day = String(originalDate.getDate()).padStart(2, "0");
  const hours = String(originalDate.getHours()).padStart(2, "0");
  const minutes = String(originalDate.getMinutes()).padStart(2, "0");

  // Format the date in the desired format
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

/***************************
 * Local Storage Utilities
 ***************************/

//return user data from local storage
export const getUser = () => {
  const userStr = localStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

export const getQrApiKey = () => {
  const userStr = "84366d00-3deb-4066-abca-3fb7adf8012025";
  return userStr;
};

//return user name from local storage
export const getName = () => {
  const userStr = localStorage.getItem("full_name");

  if (userStr) return JSON.parse(userStr);
  else return null;
};

//return user type from local storage
export const getType = () => {
  const userStr = localStorage.getItem("type");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

//return user role from local storage
export const getRole = () => {
  const userStr = localStorage.getItem("role");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

export const getIsCheck = () => {
  const userStr = localStorage.getItem("isCheck");
  if (userStr) return JSON.parse(userStr);
  else return null;
};
export const getIsTrue = () => {
  const userStr = localStorage.getItem("isTrue");
  if (userStr) return JSON.parse(userStr);
  else return null;
};
export const getVitalSignLab = () => {
  const userStr = localStorage.getItem("vitalSignLab");
  if (userStr) return JSON.parse(userStr);
  else return null;
};
export const getOpenAppointmentModal = () => {
  const userStr = localStorage.getItem("openAppointmentModal");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

//return user city from local storage
export const getCity = () => {
  const userStr = localStorage.getItem("city");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

//return user region from local storage
export const getRegion = () => {
  const userStr = localStorage.getItem("region");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

//return role id from local storage
export const getRoleId = () => {
  return localStorage.getItem("role_id") || null;
};

//return token from local storage
export const getToken = () => {
  return localStorage.getItem("token") || null;
};

//return api key from local storage
export const getKey = () => {
  return localStorage.getItem("api_key") || null;
};

//return current branch from local storage
export const getBranch = () => {
  return localStorage.getItem("branch") || null;
};

//return branch type from local storage
export const getBranchType = () => {
  return JSON.parse(localStorage.getItem("branch_type")) || null;
};

//return branch name from local storage
export const getBranchName = () => {
  return JSON.parse(localStorage.getItem("branch_name")) || null;
};

//return token expiry from local storage
export const getTokenExpiry = () => {
  return localStorage.getItem("token_expiry") || null;
};

//return services from local storage
export const getUserServices = () => {
  return localStorage.getItem("services") || null;
};

//remove token from local storage
export const removeUserSession = () => {
  // logoutUser();
  // refreshPage();
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("name");
  localStorage.removeItem("role");
  localStorage.removeItem("full_name");
  localStorage.removeItem("longitude");
  localStorage.removeItem("latitude");
};

//set the token and user from local storage
export const setUserSession = (token, api_key, user) => {
  localStorage.setItem("token", token);
  localStorage.setItem("api_key", api_key);
  localStorage.setItem("user", JSON.stringify(user));
};
